const dateOptions = [
  {
    label: 'Hoje',
    value: 'Today',
  },
  {
    label: 'Ontem',
    value: 'Yesterday',
  },
  {
    label: 'Últimos 7 Dias',
    value: 'Last7Days',
  },
  {
    label: 'Últimos 15 Dias',
    value: 'Last15Days',
  },
  {
    label: 'Últimos 30 Dias',
    value: 'Last30Days',
  },
]

export { dateOptions }
